import {META} from "./meta.js";
import DocumentMeta from "react-document-meta";

import disk_bo_tourism from './img/disk_bo_tourism.gif';
import bo_map from './img/bo_map.jpg';

const Home = () => {
    return (
        <>
            <DocumentMeta {...META()} />

            <div id="content">
                <div className="pageitem">
                    <div className="three-cell gallery" style={{width: 250}}><img src={disk_bo_tourism}/></div>

                    <h2>Общие сведения</h2>
                    <p>Брестская область расположена на юго-западе Республики Беларусь. Граничит на западе с Республикой
                        Польша, на юге – с Украиной. Территория занимает 32,7 тысячи квадратных километров, численность
                        населения - 1,5 млн. человек. На территории области расположены 3 города областного подчинения,
                        16 – районного, 9 поселков городского типа, около 2200 сельских населенных пунктов.</p>
                    <blockquote>Брестскую область знают далеко за пределами Беларуси по Брестской крепости, Беловежской
                        пуще, по железнодорожным и шоссейным магистралям, связывающим Западную Европу с Восточной.
                    </blockquote>
                    <p>Область располагает хорошо развитой транспортной инфраструктурой. Брестский железнодорожный узел
                        является одним из крупнейших в Центральной Европе и полностью обеспечивает транзит стран СНГ со
                        странами Западной Европы на Московском и Санкт-Петербургском направлениях.</p>
                    <p>Особую важность имеет автомобильный транзитный коридор «М1/Е-30»: Берлин – Варшава – Брест –
                        Минск – Москва. Разветвленная сеть железнодорожных и шоссейных дорог позволяет осуществлять
                        большое количество транзитных грузоперевозок через область (около 80 % сухопутного экспорта
                        стран СНГ в Западную Европу). Только по международной автомобильной трассе М1/Е30 ежемесячно
                        проезжает порядка 300 тыс. автотранспортных средств.</p>
                    <p>В г. Бресте расположен аэропорт, который имеет статус международного и способен принимать все
                        типы самолетов. (карты, изображения путей, аэропорта и т.д.).</p>
                    <p>В пределах г. Бреста находятся два современных автомобильных перехода с Республикой Польша. Для
                        ускорения пересечения границы действуют таможенные терминалы. На территории Брестского и
                        Каменецкого районов также имеются пограничные переходы с Польшей и Украиной. Преимущество
                        расположения Бреста у границы с Польшей усиливается в связи с вступлением последней в
                        Европейский Союз.</p>
                </div>

                <div className="two-col-cell gallery" style={{width: "90%"}}><img src={bo_map}/></div>
            </div>
        </>
    );
};

export default Home;
